import * as AlunoStoreActions from './actions';
import * as AlunoStoreSelectors from './selector';
import * as AlunoStoreState from './state';

export {
  AlunoStoreActions,
  AlunoStoreSelectors,
  AlunoStoreState
}